export default "__VITE_ASSET__XWrAgPb2__"